import { render, staticRenderFns } from "./lawsardet.vue?vue&type=template&id=355097af&scoped=true&"
import script from "./lawsardet.vue?vue&type=script&lang=js&"
export * from "./lawsardet.vue?vue&type=script&lang=js&"
import style0 from "./lawsardet.vue?vue&type=style&index=0&id=355097af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355097af",
  null
  
)

export default component.exports